module.exports = __webpack_public_path__ + "media/images/countrysquared/ky-d116c4e0d84937828d54ab84ec6fdecf.svg";